import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Space } from 'antd';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import EmployeeAssignments from '../aos/pods/components/EmployeeAssignments';

function UserPodAssignments() {
  const history = useHistory();
  const { userId } = useParams();
  const userName = history.location.state?.userName;

  return (
    <Card
      className="ant-body-scroll"
      title={
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            type="text"
            onClick={() => history.goBack()}
          />
          {userName ? `${userName} — Pod Assignment History` : 'Pod Assignment History'}
        </Space>
      }
    >
      <EmployeeAssignments employeeId={userId} />
    </Card>
  );
}

export default UserPodAssignments;
